import { useState } from "react";
import AccommodationEditModal from "./travelEdit/AccommodationEditModal";
import InboundFlightEditModal from "./travelEdit/InboundFlightEditModal";
import OutboundFlightEditModal from "./travelEdit/OutboundFlightEditModal";
import GroundTransportEditModal from "./travelEdit/GroundTransportEditModal";
import { updateBookings } from "../../../api/bookingsApi";

const TravelTab = ({ booking }) => {
  const [accIndex, setAccIndex] = useState(0);
  const [flightIndex, setFlightIndex] = useState(0);

  const [activeModal, setActiveModal] = useState(null);

  const [carImage, setCarImage] = useState(null);

  const [accommodations, setAccommodations] = useState(
    booking.accommodations || [],
  );

  const [travelLogs, setTravelLogs] = useState(booking.travel_legs || []);
  const inboundFlights = travelLogs.filter((l) => l.kind === "inbound");
  const outboundFlights = travelLogs.filter((l) => l.kind === "outbound");
  const groundTransports = travelLogs.filter((l) => l.kind === "ground");

  const currentAcc = accommodations[accIndex];

  const [inboundIndex, setInboundIndex] = useState(0);
  const [outboundIndex, setOutboundIndex] = useState(0);
  const [groundIndex, setGroundIndex] = useState(0);

  const [activeAccommodationIndex, setActiveAccommodationIndex] = useState(0);
  const [saving, setSaving] = useState(false);

  const currentInbound = inboundFlights[inboundIndex];
  const currentOutbound = outboundFlights[outboundIndex];
  const currentGround = groundTransports[groundIndex];

  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleString();
  };

  const formatAddress = (address) => {
    if (!address) return "-";

    const parts = [
      address.address_1,
      address.address_2,
      address.address_3,
      address.city,
      address.county,
      address.country,
      address.postcode,
    ];

    const filtered = parts.filter((p) => p && p.trim() !== "");

    return filtered.length ? filtered.join(", ") : "-";
  };

  const closeModal = () => setActiveModal(null);

  const handleSave = (updatedItem) => {
    if (activeModal.type === "accommodation") {
      const updated = [...accommodations];
      updated[accIndex] = updatedItem;
      setAccommodations(updated);
    } else {
      // travel_legs update (for inbound/outbound/ground)
      const updated = travelLogs.map((leg) =>
        leg.id === updatedItem.id ? updatedItem : leg,
      );

      setTravelLogs(updated);
    }

    closeModal();
  };

  const handleSaveAccommodation = async (updatedItem) => {
    try {
      setSaving(true);

      const updatedList = accommodations.map((item, index) =>
        index === activeAccommodationIndex ? updatedItem : item,
      );

      const payload = {
        accommodation: updatedList,
      };

      await updateBookings(booking.id, payload.accommodation);

      // refresh booking
      //onRefreshBooking();

      closeModal();
    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  const StarRating = ({ value }) => {
    return (
      <div>
        <div>
          <p className="text-slate-400">Hotel Rating</p>
        </div>
        <div className="flex items-center gap-1 mb-2">
          {Array.from({ length: 7 }).map((_, i) => {
            const starValue = i + 1;
            const active = starValue <= value;

            return (
              <div
                key={starValue}
                className={`text-xl transition ${
                  active ? "text-yellow-400" : "text-slate-500"
                }`}
              >
                ★
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const Dots = ({ count, active, onChange }) => (
    <div className="flex flex-col items-center mt-4 gap-2">
      <div className="flex gap-2">
        {Array.from({ length: count }).map((_, i) => (
          <button
            key={i}
            onClick={() => onChange(i)}
            className={`w-2.5 h-2.5 rounded-full transition
            ${
              active === i ? "bg-pink-500" : "bg-slate-600 hover:bg-slate-400"
            }`}
          />
        ))}
      </div>

      <span className="text-xs text-slate-400">
        {active + 1} / {count}
      </span>
    </div>
  );

  return (
    <div className="grid grid-cols-1 lg:grid-cols-6 gap-6 text-sm p-4">
      {/* ================= ACCOMMODATION ================= */}
      <div className="lg:col-span-2 bg-slate-900/80 border border-white/10 rounded-lg p-4">
        <div className="flex justify-between items-center mb-5">
          <h3 className="text-white font-semibold">Accommodation Info</h3>
          <button
            onClick={
              () => {}
              // setActiveModal({ type: "accommodation", data: currentAcc })
            }
            className="text-xs text-pink-500 hover:underline"
          >
            Edit
          </button>
        </div>

        {currentAcc ? (
          <>
            <Info label="Hotel / Place Name" value={currentAcc.hotel_name} />
            <StarRating value={Number(currentAcc.hotel_rating) || 0} />
            <LinkInfo
              label="Trip Advisor Link"
              url={currentAcc.tripadvisor_link}
            />
            <Info label="Facilities" value={currentAcc.facilities} />
            <Info
              label="Full Address"
              value={formatAddress(currentAcc.address)}
            />
            <Info label="Booking Name" value={currentAcc.contact_person} />
            <Info label="Booking No" value={currentAcc.booking} />
            <LinkInfo
              label="Booking PDF/Doc"
              url={currentAcc.confirmation_url}
            />
            <Info
              label="Airport → Hotel Travel Time"
              value={currentAcc.airport_hotel_travel_time}
            />
            <Info
              label="Hotel → Venue Travel Time"
              value={currentAcc.hotel_venue_travel_time}
            />
            <Info
              label="Check-In Date & Time"
              value={formatDate(currentAcc.check_in)}
            />
            <Info
              label="Check-Out Date & Time"
              value={formatDate(currentAcc.check_out)}
            />
          </>
        ) : (
          <p className="text-slate-400">No accommodation data</p>
        )}

        {/* Dots */}
        {accommodations.length > 1 && (
          <div className="flex flex-col items-center mt-6 gap-2">
            <div className="flex gap-2">
              {accommodations.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setAccIndex(index)}
                  className={`w-2.5 h-2.5 rounded-full transition
                    ${
                      accIndex === index
                        ? "bg-pink-500"
                        : "bg-slate-600 hover:bg-slate-400"
                    }`}
                />
              ))}
            </div>

            <span className="text-xs text-slate-400">
              {accIndex + 1} / {accommodations.length}
            </span>
          </div>
        )}
      </div>

      {/* ================= FLIGHTS ================= */}
      <div className="lg:col-span-2 bg-slate-900/80 border border-white/10 rounded-lg p-4">
        <h3 className="text-white font-semibold mb-5">Flights & Travel</h3>

        {/* INBOUND */}
        <div className="mb-6">
          <div className="flex justify-between items-center mb-2">
            <h4 className="text-slate-300">Inbound Flight</h4>
            <button
              onClick={
                () => {}
                // setActiveModal({ type: "inbound", data: currentInbound })
              }
              className="text-xs text-pink-500 hover:underline"
            >
              Edit
            </button>
          </div>

          {currentInbound ? (
            <>
              <Info
                label="Arrival Time"
                value={formatDate(currentInbound.arrival_time)}
              />
              <Info
                label="Departure Time"
                value={formatDate(currentInbound.departure_time)}
              />
              <Info label="Flight No" value={currentInbound.segment} />
              <Info label="Airline" value={currentInbound.airline} />

              <FileLink label="Ticket" url={currentInbound.document_url} />
            </>
          ) : (
            <p className="text-slate-400">No inbound flights</p>
          )}

          {/* Dots */}
          {inboundFlights.length > 1 && (
            <Dots
              count={inboundFlights.length}
              active={inboundIndex}
              onChange={setInboundIndex}
            />
          )}
        </div>

        {/* OUTBOUND */}
        <div>
          <div className="flex justify-between items-center mb-2">
            <h4 className="text-slate-300">Outbound Flight</h4>
            <button
              onClick={
                () => {}
                // setActiveModal({ type: "outbound", data: currentOutbound })
              }
              className="text-xs text-pink-500 hover:underline"
            >
              Edit
            </button>
          </div>

          {currentOutbound ? (
            <>
              <Info
                label="Departure Time"
                value={formatDate(currentOutbound.departure_time)}
              />
              <Info
                label="Arrival Time"
                value={formatDate(currentOutbound.arrival_time)}
              />
              <Info label="Flight No" value={currentOutbound.segment} />
              <Info label="Airline" value={currentOutbound.airline} />

              <FileLink label="Ticket" url={currentOutbound.document_url} />
            </>
          ) : (
            <p className="text-slate-400">No outbound flights</p>
          )}

          {/* Dots */}
          {outboundFlights.length > 1 && (
            <Dots
              count={outboundFlights.length}
              active={outboundIndex}
              onChange={setOutboundIndex}
            />
          )}
        </div>
      </div>

      {/* ================= GROUND TRANSPORT ================= */}
      <div className="lg:col-span-2 bg-slate-900/80 border border-white/10 rounded-lg p-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-white font-semibold">Ground Transport</h3>
          <button
            onClick={
              () => {}
              // setActiveModal({ type: "ground", data: currentGround })
            }
            className="text-xs text-pink-500 hover:underline"
          >
            Edit
          </button>
        </div>

        {currentGround ? (
          <>
            <Info label="Driver Name" value={currentGround.driver_name} />
            <Info label="Driver Phone" value={currentGround.driver_phone} />
            <Info label="Car Make" value={currentGround.make} />
            <Info label="Model" value={currentGround.model} />
          </>
        ) : (
          <p className="text-slate-400">No transport data</p>
        )}

        {/* Dots */}
        {groundTransports.length > 1 && (
          <Dots
            count={groundTransports.length}
            active={groundIndex}
            onChange={setGroundIndex}
          />
        )}
      </div>

      {/* ================= CAR IMAGE MODAL ================= */}
      {carImage && (
        <div
          className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
          onClick={() => setCarImage(null)}
        >
          <div className="bg-slate-900 p-4 rounded-lg max-w-lg w-full">
            <img src={carImage} alt="Car" className="w-full h-auto rounded" />
          </div>
        </div>
      )}

      {activeModal?.type === "accommodation" && (
        <AccommodationEditModal
          isOpen
          initialData={activeModal.data}
          onClose={closeModal}
          onSave={handleSave}
        />
      )}
      {activeModal?.type === "inbound" && (
        <InboundFlightEditModal
          isOpen
          initialData={activeModal.data}
          onClose={closeModal}
          onSave={handleSave}
        />
      )}

      {activeModal?.type === "outbound" && (
        <OutboundFlightEditModal
          isOpen
          initialData={activeModal.data}
          onClose={closeModal}
          onSave={handleSave}
        />
      )}

      {activeModal?.type === "ground" && (
        <GroundTransportEditModal
          isOpen
          initialData={activeModal.data}
          onClose={closeModal}
          onSave={handleSave}
        />
      )}
    </div>
  );
};

const Info = ({ label, value }) => (
  <div className="mb-2">
    <p className="text-slate-400">{label}</p>
    <p className="text-white">{value || "-"}</p>
  </div>
);

const FileLink = ({ label, url }) => (
  <div className="mb-2">
    <p className="text-slate-400">{label}</p>
    {url ? (
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        className="text-pink-500 hover:underline"
      >
        View
      </a>
    ) : (
      <p className="text-white">-</p>
    )}
  </div>
);

const LinkInfo = ({ label, url }) => (
  <div className="mb-2">
    <p className="text-slate-400">{label}</p>

    {url ? (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-pink-500 hover:underline break-all"
      >
        Open Link
      </a>
    ) : (
      <p className="text-white">-</p>
    )}
  </div>
);

export default TravelTab;
